export const RTL = 'rtl';
export const LTR = 'ltr';

const locales = [
  ['en', 'English', 'English'],
  ['hi', 'हिंदी', 'Hindi'],
  ['ar', 'العربية', 'Arabic'],
  ['fa', 'فارسی', 'Persian'],
  ['bn', 'বাংলা', 'Bengali'],
  ['kn', 'ಕನ್ನಡ', 'Kannada'],
  ['ml', 'മലയാളം', 'Malayalam'],
  ['mr', 'मराठी', 'Marathi'],
  ['ur', 'اردو', 'Urdu'],
];

export default locales;
